import axios from 'axios'
import {saveAs} from 'file-saver'

export const downloadFile = async (url: string, filename: string): Promise<void> => {
  try {
    const response = await axios.create().get(url, {responseType: 'blob'})
    saveAs(response.data, filename)
  } catch {
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    link.rel = 'noopener noreferrer'
    document.body.appendChild(link)
    link.click()
    link.remove()
  }
}
